import React, { Component } from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

// Components
import ResultsVisualization from '../resultsvisualization';

class QuizVisualization extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showResults: false,
		};
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			showResults: nextProps.questionResultsVisualization && nextProps.questionResultsVisualization.show,
		});
	}

	render() {
		const {
			isLoading,
			status,
			enabled,
			locale,
			theming,
			questionResultsVisualization,
		} = this.props;

		// Loading
		if (isLoading && (status !== 'initialized')) {
			return null;
		}

		// Loaded, but crashed
		if (status === 'failed') {
			return (
				<div />
			);
		}

		// Loaded, but disabled
		if (!enabled) {
			return null;
		}
		if (questionResultsVisualization.question) {
			const results = (questionResultsVisualization || {}).results || { answers: {}, correct: [] };
			const answers = questionResultsVisualization.question.answers || [];
			const studio = questionResultsVisualization.studio || (questionResultsVisualization.quiz || {}).studio;

			const choicesWithResults = _.map(answers, answer => ({
				idx: answer.id,
				numVotes: results.answers[answer.id] ? results.answers[answer.id] : 0,
				title: answer.text,
				correct: results.correct.indexOf(answer.id) !== -1,
			}));

			const questionText = questionResultsVisualization.question.text;
			const questionIndex = questionResultsVisualization.question.launchIndex;

			return (
				<div style={{
					height: '100%',
					width: '100%',
				}}
				>
					<ResultsVisualization
						questionText={questionText}
						locale={locale}
						theming={theming}
						choices={choicesWithResults}
						backgroundUrl={undefined}
						showResults={this.state.showResults}
						questionIndex={questionIndex}
						background={studio}
					/>
				</div>
			);
		}

		return (
			<div>
				<p>{locale['quiz.nopoll.message'] || ''}</p>
			</div>
		);
	}
}

QuizVisualization.propTypes = {
	enabled: PropTypes.bool.isRequired,
	isLoading: PropTypes.bool.isRequired,
	status: PropTypes.string.isRequired,
	locale: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	theming: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	questionResultsVisualization: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

QuizVisualization.defaultProps = {};

export default QuizVisualization;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/quizvisualization/QuizVisualization.component.js